import { useState, useEffect } from 'react';
import { DataServiceHookResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { isEmpty } from '@dxb-web-ui-framework/common/utils';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useSelectedCustomerId } from '../../../../../userProfile/src/contexts/UserInfo/hooks';
import { useBulkSelectedAuthorizations, useInitiateBulkMandatesService } from '../../../contexts';
import { InitiateMandateResponseBody } from '../../../domain/Authorization/entities/InitiateMandateResponseDTO';

const useMandateBulkInitiateService = (
  authAction: Nullable<string>,
  cancellationReason?: string,
  dealerRateRequest?: boolean,
): DataServiceHookResponse<InitiateMandateResponseBody> => {
  const [timestamp, setTimestamp] = useState<Nullable<string>>(null);

  const bulkSelectedAuthorizations = useBulkSelectedAuthorizations();
  const selectedCustomerId = useSelectedCustomerId() || '';

  const initiateBulkMandatesService = useInitiateBulkMandatesService()();

  const shouldInitiateAuthorization = Boolean(
    !isEmpty(bulkSelectedAuthorizations) &&
      bulkSelectedAuthorizations !== null &&
      authAction !== null &&
      (Boolean(authAction === 'approve') || Boolean(authAction === 'reject' && Boolean(cancellationReason))) &&
      Boolean(timestamp),
  );

  useEffect(() => {
    if (!timestamp) {
      setTimestamp(new Date().toISOString());
    }
  }, [timestamp]);

  // Initiate Authorizations
  return useInvokeSWRService<InitiateMandateResponseBody>(
    initiateBulkMandatesService,
    {
      mandates: bulkSelectedAuthorizations?.map(mandate => ({
        appTransactionId: parseInt(mandate.transactionId),
        accepted: authAction === 'approve' ? true : false,
        cancellationReason,
        orderCode: mandate.globalOrderId,
        dealerRateRequest: Boolean(dealerRateRequest),
      })),
      customerId: selectedCustomerId,
      meta: { timestamp },
    },
    shouldInitiateAuthorization,
    'authorizationService.InitiateBulkMandates',
  );
};

export { useMandateBulkInitiateService };
